function alertsController($localStorage, $state, $scope, WS, $window, $compile, $parse) {
    'ngInject';
    const vm = this;

}
export default {
    name: 'alertsController',
    fn: alertsController
};
